import $ from 'jquery'
window.$ = $
window.jQuery = $
export default $



// WEBPACK FOOTER //
// ./src/assets/jquery_loader.js